import { render, staticRenderFns } from "./getMore.vue?vue&type=template&id=6f73e06d&scoped=true"
import script from "./getMore.vue?vue&type=script&lang=js"
export * from "./getMore.vue?vue&type=script&lang=js"
import style0 from "./getMore.vue?vue&type=style&index=0&id=6f73e06d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73e06d",
  null
  
)

export default component.exports